var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganismInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "organism_inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Back-Office",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B\\xE9n\\xE9ficaires",
    transform: "translate(-31.000000, -251.000000)",
    stroke: "#9B9FA4",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "organism_inactive",
    transform: "translate(31.750000, 251.750000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10.5,
    x2: 10.5,
    y2: 10.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "1.16666667 10.5 1.16666667 2.33333333 5.83333333 0 5.83333333 10.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "9.33333333 10.5 9.33333333 4.66666667 5.83333333 2.33333333"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 3.5,
    x2: 3.5,
    y2: 3.50583333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 5.25,
    x2: 3.5,
    y2: 5.25583333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 7,
    x2: 3.5,
    y2: 7.00583333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 8.75,
    x2: 3.5,
    y2: 8.75583333,
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganismInactive);
export default __webpack_public_path__ + "static/media/organism_inactive.2a28b0d28258afccfff3dccf8a76b944.svg";
export { ForwardRef as ReactComponent };